<template>
  <section class="layout-proyectos">
    <div class="row max-width-md section-title pb-3 pt-6">
      <div class="col-12">
        <h1>
          Nuestros Proyectos
        </h1>
        <p>
          Nuestra diferenciación es el apego a elevados estándares de calidad y
          seguridad, así como el alto sentido de responsabilidad con el cual
          asumimos los retos de nuestros clientes.
        </p>
      </div>
    </div>

    <gallery
      :list-images="GALLERY_IMAGES"
      :list-videos="GALLERY_VIDEOS"
      :list-media="GALLERY"
    />
  </section>
</template>

<script>
import Gallery from '@/components/gallery.vue';
import { GALLERY_IMAGES, GALLERY_VIDEOS, GALLERY } from '@/config';

export default {
  name: 'SectionProyectos',
  components: {
    Gallery,
  },
  data() {
    return {
      GALLERY_IMAGES,
      GALLERY_VIDEOS,
      GALLERY,
    };
  },
};
</script>
<style lang="scss" scoped>
.layout-proyectos--video {
  overflow: hidden;
}
</style>
